import { Component, OnInit, inject } from '@angular/core';
import { InfoService } from '../../shared/services/info.service';

@Component({
    selector: 'ldw-no-webdoku-page',
    templateUrl: './no-webdoku-page.component.html',
    styleUrls: ['./no-webdoku-page.component.css'],
    standalone: false
})
export class NoWebdokuPageComponent implements OnInit {
  private infoService = inject(InfoService);

  ngOnInit(): void {
    this.infoService.clearStatus();
  }

}
